import React from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import CustomDivider from "../../Utils/CustomDivider/CustomDivider";
import { useState } from "react";
import AllRequestTable from "../All-Request-Table/AllRequestTable";

export default function AllRequestScreen() {
  const [activeButton, setActiveButton] = useState(true);

  return (
    <Container>
      <TitleElement>
        <ImgContainer>
          <TitleIcon src="/Assets/Images/SendReqActive.png"></TitleIcon>
        </ImgContainer>
        <TitleText>پیگیری درخواست</TitleText>
      </TitleElement>
      <CustomDivider></CustomDivider>
      <ContainerButton>
        {activeButton ? (
          <>
            <PageButtonActive>درخواست های فعال</PageButtonActive>
            <PageButton onClick={() => setActiveButton(false)}>
              درخواست های آرشیو
            </PageButton>
          </>
        ) : (
          <>
            <PageButton onClick={() => setActiveButton(true)}>
              درخواست های فعال
            </PageButton>
            <PageButtonActive>درخواست های آرشیو</PageButtonActive>
          </>
        )}
      </ContainerButton>
      <AllRequestTable></AllRequestTable>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  direction: rtl;
  box-sizing: border-box;
  padding: 5px;
`;

const TitleElement = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const ImgContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid #f5f7f8;
  background-color: transparent;
  border-radius: ${Theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleIcon = styled.img`
  object-fit: contain;
`;

const TitleText = styled.p`
  height: 40px;
  font-size: ${Theme.fontTitleSize};
  font-weight: ${Theme.fontInfoWeight};
  line-height: 41px;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const ContainerButton = styled.div`
  width: 320px;
  height: 55px;
  background-color: ${Theme.colorBackgroundPage};
  display: flex;
  border-radius: ${Theme.borderRadius};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
  box-sizing: border-box;
  transition: all 500ms ease;
`;
const PageButton = styled.button`
  width: 45%;
  margin: 0.3rem auto;
  border-radius: 8px;
  font-family: "IranSans";
  padding: 8px;
  text-align: center;
  border: none;
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeigh};
  color: ${Theme.colorFontBlack};
  background-color: transparent;
  transition: all 500ms ease;
  border: 1px solid ${Theme.colorBackgroundPage};
  cursor: pointer;

  &:hover {
    border: 1px solid ${Theme.colorBackgroundBoxHover};
  }
`;

const PageButtonActive = styled.button`
  width: 45%;
  margin: 0.3rem auto;
  border-radius: 8px;
  font-family: "IranSans";
  padding: 8px;
  text-align: center;
  border: none;
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeigh};
  color: ${Theme.colorFontWhite};
  background-color: ${Theme.colorBluePrimary};
  transition: all 500ms ease;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
